import React, { useState } from 'react';

const lookingFor = [
  'For information about SpaceMap',
  'To work with SpaceMap',
  'To invest in SpaceMap',
  'To connect with SpaceMap about another topic',
];

const ContactForm = () => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [message, setMessage] = useState('');
  const [lookingForIndex, setLookingForIndex] = useState(0);

  const checkKey = (e: React.KeyboardEvent) => {
    if (
      e.key === 'PageUp' ||
      e.key === 'ArrowUp' ||
      e.key === 'PageDown' ||
      e.key === 'ArrowDown'
    )
      e.stopPropagation();
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const formData = {
      email,
      name,
      message,
      lookingFor: lookingFor[lookingForIndex],
    };

    const response = await fetch(process.env.REACT_APP_EMAIL_ENDPOINT, {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'no-cors',
    });

    if (response) {
      alert('Email sent successfully. We will get back to you shortly.');
      resetForm();
    } else {
      alert('Email failed to send. Please try again later.');
    }
  };

  const resetForm = () => {
    setEmail('');
    setName('');
    setMessage('');
    setLookingForIndex(0);
  };

  return (
    <form
      id='emailForm'
      className='gform w-full flex flex-col justify-center items-start gap-4'
      onSubmit={handleSubmit}
    >
      <div className='flex flex-col gap-2 w-full'>
        <label htmlFor='name' className='text-white'>
          Name
        </label>
        <input
          type='text'
          className='form-control w-full font-kanit border border-white placeholder-gray-500 placeholder:font-kanit xl:text-white bg-transparent rounded-md p-2'
          id='name'
          name='name'
          placeholder='Your Name'
          required
          value={name}
          onChange={e => setName(e.target.value)}
          onKeyDown={e => checkKey(e)}
        />
      </div>

      <div className='flex flex-col gap-2 w-full'>
        <label htmlFor='email' className='text-white'>
          Email
        </label>
        <input
          type='text'
          className='form-control w-full font-kanit border border-white placeholder-gray-500 placeholder:font-kanit xl:text-white bg-transparent rounded-md p-2'
          id='email'
          name='email'
          placeholder='Your Email'
          required
          value={email}
          onChange={e => setEmail(e.target.value)}
          onKeyDown={e => checkKey(e)}
        />
      </div>

      <div className='flex flex-col gap-2 w-full'>
        <label htmlFor='lookingFor' className='text-white'>
          Looking For
        </label>
        <select
          className='form-control w-full border border-white font-kanit text-white bg-transparent rounded-md p-2'
          value={lookingFor[lookingForIndex]}
          onChange={e => {
            const index = lookingFor.indexOf(e.target.value);
            setLookingForIndex(index);
          }}
        >
          {lookingFor.map((item, index) => (
            <option key={index} value={item}>
              {item}
            </option>
          ))}
        </select>
      </div>

      <div className='flex flex-col gap-2 w-full'>
        <label htmlFor='message' className='text-white'>
          Message
        </label>
        <textarea
          className='form-control w-full border border-white placeholder-gray-500 placeholder:font-kanit font-kanit xl:text-white bg-transparent rounded-md p-2'
          id='message'
          name='message'
          rows={5}
          placeholder='Your Message'
          value={message}
          onChange={e => setMessage(e.target.value)}
          onKeyDown={e => checkKey(e)}
        />
      </div>

      <div className='form-group mt-2 md:mt-4 w-full flex justify-end'>
        <button
          id='btnSubmit'
          className='btn-submit w-full md:w-auto h-12 md:h-10 md:px-[18px] md:py-2 rounded-md text-[16px] font-semibold md:text-[18px] text-[#C6C6C6] cursor-pointer flex justify-center items-center bg-[#4B4B4B]'
        >
          Send
        </button>
      </div>
    </form>
  );
};

export default ContactForm;
